import React, { useState, useEffect } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../modules/Base/Auth/contexts/AuthContext';
import { FaChevronLeft } from 'react-icons/fa';
import { findCurrentPage } from '../NavComponent/findCurrentPage';
import styles from './TopNav.module.css';

export default function TopNav() {
  const { user, logout, isAuthenticated, isLoading } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  const [currentRole, setCurrentRole] = useState(null);
  const [currentPage, setCurrentPage] = useState(null);

  useEffect(() => {
    const { activeRole, activePage } = findCurrentPage(location.pathname);
    setCurrentRole(activeRole);
    setCurrentPage(activePage);
  }, [location.pathname]);

  const handleBack = () => {
    if (currentPage) navigate(`/${currentRole.key}`);
    else navigate('/');
  };

  if (isLoading) return null;

  const isHome = location.pathname === '/';

  return (
    <nav className={styles.TopNav}>
      <div className={styles.breadcrumbs}>
        {/* Кнопка назад */}
        {!isHome && (
          <button onClick={handleBack} className={styles.backButton}>
            <FaChevronLeft />
          </button>
        )}

        {/* Кнопки навигации */}
        <Link to="/" className={`${styles.navBtn} ${styles.homeBtn}`}>
          <i className="bi bi-house-door" /> Главная
        </Link>

        {currentRole && (
          <>
            <span className={styles.separator}>›</span>
            <Link to={`/${currentRole.key}`} className={styles.navBtn}>
              <i className={`bi ${currentRole.icon}`} /> {currentRole.label}
            </Link>
          </>
        )}

        {currentPage && (
          <>
            <span className={styles.separator}>›</span>
            <span className={`${styles.navBtn} ${styles.currentPage} ${styles.disabledBtn}`}>
              {currentPage.label}
            </span>
          </>
        )}
      </div>


      <div className={styles.userSection}>
        {isAuthenticated ? (
          <>
            {user.username}
            <button onClick={logout} className={styles.logoutBtn}>
              <i className="bi bi-box-arrow-right" />
            </button>
          </>
        ) : (
          <Link to="/login" className={styles.loginLink}>
            Войти
          </Link>
        )}
      </div>
    </nav>
  );
}
